if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loading === 'true' || this.dataset.loaded === 'true') return;

      // This row sits far below the fold; fetching it at parse time competes
      // with LCP resources for bandwidth and main thread.
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          this.load();
        }, { rootMargin: '0px 0px 400px 0px' });
        observer.observe(this);
      } else {
        this.load();
      }
    }

    load() {
      if (this.dataset.loading === 'true' || this.dataset.loaded === 'true') return;

      this.dataset.loading = 'true';
      const url = new URL(this.dataset.url, window.location.origin);
      url.searchParams.set('section_id', this.dataset.sectionId);
      url.searchParams.set('product_id', this.dataset.productId);

      fetch(url.toString(), {
        credentials: 'same-origin',
        headers: { Accept: 'text/html' },
      })
        .then((response) => {
          if (!response.ok) throw new Error('Recommendations request failed');
          return response.text();
        })
        .then((html) => {
          const responseDocument = new DOMParser().parseFromString(html, 'text/html');
          const recommendations = responseDocument.querySelector('product-recommendations');

          if (!recommendations || !recommendations.children.length) {
            this.hidden = true;
            return;
          }

          this.innerHTML = recommendations.innerHTML;
          this.dataset.loaded = 'true';
          requestAnimationFrame(() => window.tmgInitCollectionSwipers?.());
        })
        .catch(() => {
          this.dataset.loading = 'false';
        });
    }
  });
}
